import { format } from "../../libs/date.format";

const fullWeekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];

const formatRawDate = (date) => {
    if (date === undefined) {
        return "";
    }

    const day = new Date(date).getDay();

    return `${fullWeekdays[day]} ${format(date, "dS mmmm yyyy")}`;
};

export default formatRawDate;
